export type MqttMode = 'legacy' | 'acl' | 'disabled';

export function resolveMqttMode(value = process.env.REACT_APP_MQTT_MODE): MqttMode {
  if (value === undefined || value === '' || value === 'legacy') return 'legacy';
  return value === 'acl' ? 'acl' : 'disabled';
}

export const legacyBrokerUrl = process.env.REACT_APP_MQTT_URL || 'wss://api-broker.scfg.io';
